module.exports = __webpack_public_path__ + "media/img/corporate/cover3-45d32d349abe016a92061c4fa0d81e58.png";